import React, { useCallback, useEffect, useState } from 'react';
import AccentureLogo from '../../../../../src/img/Accenture-Logo-white@2x.png';
import ButtonIcon from '../../button';
import { ConfirmationNotificationModal } from '../modal/confirmation-modal.component';
import { MODAL_CUSTOM_MESSAGE } from '../../../constants/external-constants';
import { Loading } from '../loading';
import { bindActionCreators } from '@reduxjs/toolkit';
import { stripeActions } from '../../../store/common/stripe/stripe.reducer';
import { connect } from 'react-redux';

const PaymentDetails = ({ orderId, orderNumber, cardholderName, cardNumberLast4, expiryDate, billingAddress, 
                            cardType, enableDeleteBtn, onClearPaymentMethod, isLoading,
                          virtualCardEnabled, fundGenerateVirtualCard, fetchVirtualCardInfo,
                           virtualCardInfo, amount, customerEmail, customerPhone, resetCardData }) => {
    const [showModal, setShowModal] = useState(false);
    const [isGeneratingVcard, setIsGeneratingVcard] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [activeButton,setActiveButton] = useState('physical');
    const [internalLoading, setInternalLoading] =useState(false);
  
    

    const getVirtualCardData = useCallback(async () => {
      if (orderId) {
        try {
          setInternalLoading(true);
          await fetchVirtualCardInfo(orderId);
          setInternalLoading(false);
        } catch (error) {
          setInternalLoading(false);
        }
      }
    }, [orderId, fetchVirtualCardInfo]);


    useEffect(() => {
      getVirtualCardData();
    }, [getVirtualCardData]);

    const handleRemoveCard = ()=>{
        setShowModal(true)
    }

    useEffect(() => {
      return () => {
        resetCardData();
      };
    }, [resetCardData]);

   const handleCreateNewConf= (buttonType) => {
        if(buttonType==="ok")
        {
            if(onClearPaymentMethod) {
                onClearPaymentMethod();
            }
           setShowModal(false)
        } else {
           setShowModal(false)
        }
    };

  const handleGenerateVirtualCard = async ()=>{

    setIsGeneratingVcard(true);
    setErrorMessage('');
    const result = await fundGenerateVirtualCard(orderId);
     if (result.success) {
            getVirtualCardData();
        } else {
            setErrorMessage(result.message);
        }

        setIsGeneratingVcard(false);
  }

  const handleToggle = (buttonName)=>{
    setActiveButton(buttonName);
  }

  if (isLoading || internalLoading) {
    return <Loading />;
  };

  const displayCardType = activeButton === 'virtual' ? virtualCardInfo?.VirtualCardBrand : cardType;
  const displayCustomerName = activeButton === 'virtual' ? virtualCardInfo?.VirtualName : cardholderName;
  const displayExpireDate =  activeButton === 'virtual' && virtualCardInfo ? `${virtualCardInfo.VirtualExpMonth}/${virtualCardInfo.VirtualExpYear}` : expiryDate;
  return (
    <div className={`${virtualCardEnabled ? 'mt-6' : ''} payment-details-wrapper`}>
       {
        virtualCardEnabled &&
          <div className="payment-details-info d-flex justify-content-end mb-4">
            <div className="text-end">
              <div className="d-flex justify-content-between">
                <span className="text-secondary me-5">ORDER NUMBER</span>
                <span className="fw-semibold">{orderNumber}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-secondary me-5">TOTAL AMOUNT</span>
                <span className="fw-semibold">${amount}</span>
              </div>
            </div>
        </div>
       }
      {
        virtualCardInfo?.VirtualStatus?.toLowerCase() === "active" &&
          <div id="card-toggle" className="btn-group w-100 mb-4" role="group">
              <button id="virtual-card-btn" 
                      onClick={() => handleToggle('physical')}
                      type="button" className={`btn btn-light w-50 ${activeButton === 'physical' ? 'active' : ''}`}>
                        Physical Card
              </button>
              <button id="physical-card-btn" 
                      onClick={() => handleToggle('virtual')}
                      type="button" className={`btn btn-light w-50 ${activeButton === 'virtual' ? 'active' : ''}`}>
                        Virtual Card
              </button>
          </div>
      }

      <div className={`credit-card-custom d-flex flex-column 
                      justify-content-between rounded-4 p-4 
                      text-white shadow-lg ${activeButton === 'virtual' ? 'virtual-card-active' : ''}`}
      >

        {/* Card Top */}
        <div className="d-flex justify-content-between align-items-center">           
          <div className="rounded d-flex justify-content-center align-items-center">
            <img src={AccentureLogo} className="card-main-logo" alt="accenture" />
          </div>
          <div className="fs-4 fw-bold fst-italic">{displayCardType}</div>
        </div>

        {/* Card Number */}

         {activeButton === 'virtual' && virtualCardInfo?.VirtualNumber ? (
            <div className="d-flex justify-content-between fs-5 card-number-spacing">
              {
                virtualCardInfo.VirtualNumber.match(/.{1,4}/g).map((chunk, index) => (
                  <span key={`card-chunk-${index}`}>{chunk}</span>
                ))
              }
            </div>
          ) : (
            <div className="d-flex justify-content-between fs-5 card-number-spacing">
              <span>••••</span>
              <span>••••</span>
              <span>••••</span>
              <span>{cardNumberLast4}</span>
        </div>
          )}       

        {/* Card Bottom */}
        <div className="d-flex justify-content-between text-uppercase">
            <div>
              <small className="d-block opacity-75 mb-1">CARDHOLDER NAME</small>
              <span className="fs-6 fw-medium">{displayCustomerName}</span>
            </div>

            {activeButton === 'virtual' && (
                <div className="text-center">
                  <small className="d-block opacity-75 mb-1">CVC</small>
                  <span className="fs-6 fw-medium">{virtualCardInfo?.VirtualCvc}</span>
                </div>
              )}

            <div className="text-end">
              <small className="d-block opacity-75 mb-1">EXPIRES</small>
              <span className="fs-6 fw-medium">{displayExpireDate}</span>
            </div>
          </div>
        </div>
      

       <div className="row mt-4">
          <div className="col-md-6 border-end pe-md-4">
            <h3 className="text-secondary small text-uppercase fw-semibold mb-2">BILLING ADDRESS:</h3>
            <div className="small lh-base">
              <div>{billingAddress}</div>
            </div>
          </div>

          <div className="col-md-6 ps-md-4">
            <h3 className="text-secondary small text-uppercase fw-semibold mb-2">CONTACT INFORMATION:</h3>
            <div className="small lh-base">
                <div className="mb-2">
                    <div className="text-secondary">Email Address:</div>
                    <div className="fw-medium">{customerEmail}</div>
                </div>
                <div>
                    <div className="text-secondary">Phone Number:</div>
                    <div className="fw-medium">{customerPhone}</div>
                </div>
            </div>
        </div>
        </div>

      {
        enableDeleteBtn &&
        <div className="d-flex justify-content-center w-100 mt-4">
            <ButtonIcon
                onClick={handleRemoveCard}
                iconSize="17px"
                iconLeft="trash-can"
                customClassName="btn-solid-color remove-card-btn"
                labelName="Remove Card"
            />           
        </div>
      }  
      
      {
        (virtualCardEnabled && virtualCardInfo?.VirtualStatus?.toLowerCase() !== "active") &&
          <div className="mt-4">            
              <button onClick={handleGenerateVirtualCard} disabled={isGeneratingVcard} className={`btn btn-primary ${isGeneratingVcard ? 'w-70' : 'w-50'} d-block mx-auto mt-3`}>
                    {isGeneratingVcard ? 'Generating Virtual Card In Progress...' : 'Generate Virtual Card'}
                </button>
          </div> 
      }

       <ConfirmationNotificationModal
            show={showModal}
            message={MODAL_CUSTOM_MESSAGE.remove_credit_card_info}
            title={'Remove Card Details'}
            handleModal={handleCreateNewConf}
            customClass={'comment-notification-modal modal-text-bold'}
        />  
    </div>
  );
};

const mapStateToProps = (state) => ({
    virtualCardInfo: state.stripeDetails?.virtualCardInfo 
});

const mapDispatchToProps = (dispatch) => 
    bindActionCreators(Object.assign({}, stripeActions), dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentDetails);